(() => {
  document.addEventListener('change', event => {
    if (!event.target.matches('[name="selling_plan"]')) return;
    const section = event.target.closest('.product-detail');
    section?.querySelectorAll('[data-product-option]').forEach(link => {
      const url = new URL(link.href);
      if (event.target.value) url.searchParams.set('selling_plan', event.target.value);
      else url.searchParams.delete('selling_plan');
      link.href = url.toString();
    });
  });
  document.addEventListener('submit', async event => {
    const form = event.target.closest('[data-product-form]');
    if (!form || !window.Giesen?.cart) return;
    event.preventDefault();
    if (form.dataset.submitting === 'true' || form.dataset.uncertain === 'true') return;
    const body = new FormData(form);
    const button = form.querySelector('[name="add"]');
    const error = form.querySelector('[data-product-error]');
    const cartLink = form.querySelector('[data-product-cart-link]');
    form.dataset.submitting = 'true'; button.disabled = true; error.hidden = true;
    try {
      await window.Giesen.cart.mutate(window.Giesen.routes.cartAdd, body);
      button.disabled = false;
      window.Giesen.cart.open(event.submitter || button);
    } catch (failure) {
      error.textContent = (failure.message || 'We could not confirm your order change.') + ' Please review your cart before adding again.';
      error.hidden = false; cartLink.hidden = false;
      // A disconnected response may follow a successful add. Require a cart review,
      // rather than offering a duplicate request or falling back to form submission.
      form.dataset.uncertain = 'true';
    } finally {
      form.dataset.submitting = 'false';
      button.disabled = form.dataset.uncertain === 'true';
    }
  });
})();
